import { DebinState } from './types'

const initialState: DebinState = {
  isLoading: false,
  isDebinMovementsLoading: false,
  isError: false,
  recurrences: [],
  debinMovements: []
}

export default initialState
